import React from 'react';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

type SkeletonLoaderProps = {
  minwidth?: number | string;
  height?: number | string;
  rowsNumber?: number;
};

export const SkeletonLoader = ({
  minwidth = '100%',
  height = 60,
  rowsNumber = 7,
}: SkeletonLoaderProps) => {
  return (
    <Box
      sx={(theme) => ({
        border: `0 solid ${theme.palette.divider}`,
        padding: theme.spacing(0.75, 1),
        borderRadius: theme.shape.borderRadius,
      })}
    >
      {Array.from({ length: rowsNumber }).map((_, i) => (
        <Skeleton key={i} variant="text" width={minwidth} height={height} />
      ))}
    </Box>
  );
};
